// eslint-disable-next-line no-shadow
enum remoteEnum {
  get,
  post,
  put,
  delete,
  patch,
  noAction,
  getBlob,
  postBlob
}

export default remoteEnum
